import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { SharedFeatureLocationSelectorModule } from '@usheru-hff/shared/feature-location-selector';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { SharedUiModalMapModule } from '@usheru-hff/shared/ui-modal-map';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { RouterModule } from '@angular/router';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { HffCommonUiUsheruLogoModule } from '@usheru-hff/hff-common/ui-usheru-logo';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShowtimeStreamingInCinemasComponent } from './showtime-streaming-in-cinemas/showtime-streaming-in-cinemas.component';
import { ShowtimeStreamingInCinemasComponent as ShowtimeStreamingInCinemasNewComponent } from './showtime-streaming-in-cinemas/showtime-streaming-in-cinemas.component';
import { PerformanceComponent as PerformanceNewComponent } from './showtime-streaming-in-cinemas/performance/performance.component';
import { DatesCarouselComponent } from './dates-carousel/dates-carousel.component';
import { UiDateComponent } from './ui-date/ui-date.component';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';
import { UiAttributeComponent } from './ui-attribute/ui-attribute.component';
import { UiHourComponent } from './ui-hour/ui-hour.component';
import { ShowtimeStreamingSubscribeComponent, FormSubscriptionComponent } from '@usheru-hff/movie-detail/feature-subscribe';
import { ButtonModule } from 'primeng/button';
import { UshShowtimeDatesComponent } from './ush-showtime-dates/ush-showtime-dates.component';
import { ShowtimeStreamingMapComponent } from './showtime-streaming-in-cinemas/showtime-streaming-map/showtime-streaming-map.component';
import { LoadMoreCinemasComponent } from './load-more-cinemas.component';
import { PerformanceHeaderComponent } from './showtime-streaming-in-cinemas/performances-header/performance-header.component';
import { ShowtimesStoreService } from './shared/showtimes.service';
import {SkeletonModule} from "primeng/skeleton";
@NgModule({
  imports: [
    LoadMoreCinemasComponent,
    CommonModule,
    RouterModule.forChild([]),
    AccordionModule,
    SharedFeatureLocationSelectorModule,
    ButtonModule,
    LoadingIndicatorComponent,
    SharedUtilsTranslationModule,
    SharedUtilsImageModule,
    SharedUiModalMapModule,
    SharedUtilsModule,
    HffCommonUiUsheruLogoModule,
    FontAwesomeModule,
    SwiperDirective,
    SkeletonModule,
    ShowtimeStreamingSubscribeComponent, 
    FormSubscriptionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    PerformanceNewComponent,
    ShowtimeStreamingInCinemasComponent,
    UshShowtimeDatesComponent,
    DatesCarouselComponent,
    UiDateComponent,
    UiAttributeComponent,
    UiHourComponent,
    ShowtimeStreamingMapComponent,
    PerformanceHeaderComponent
  ],
  providers: [ShowtimesStoreService],
  exports: [ShowtimeStreamingInCinemasComponent, ShowtimeStreamingInCinemasNewComponent]
})
export class MovieDetailFeatureShowtimesModule {}
